import {timedPayload} from "./rentalTime";

const priceFields = ["vehicle_id", "start_date", "end_date_planned", "start_time", "end_time", "start_fold", "end_fold"];
const quoteFields = ["client_id", "vehicle_id", "start_date", "end_date_planned", "start_at", "end_at", "agreed_amount", "conditions", "internal_note", "preparation_minutes", "km_terms"];

export function vehiclePriceInputKey(form) {
  return JSON.stringify({pricing_mode: form.pricing_mode || "daily", ...Object.fromEntries(priceFields.map(field => [field, form[field] || ""]))});
}

export function affectsVehiclePrice(field) {
  return field === "pricing_mode" || priceFields.includes(field);
}

export function vehiclePriceKey(form, revision) {
  return JSON.stringify([vehiclePriceInputKey(form), revision]);
}

export function vehiclePreviewPayload(form, revision) {
  if (!["combined", "daily", "monthly"].includes(form.pricing_mode || "daily")) throw new Error("Scegli la combinazione più conveniente o la tariffa giornaliera.");
  if (!form.start_date || !form.end_date_planned) throw new Error("Indica ritiro e rientro per calcolare il prezzo.");
  if (form.end_date_planned < form.start_date) throw new Error("Il rientro non può precedere il ritiro.");
  const period = timedPayload(Object.fromEntries(priceFields.filter(field => field !== "vehicle_id").map(field => [field, form[field] || ""])));
  // This endpoint accepts the period and revision only, never quote or UI fields.
  return {pricing_mode: form.pricing_mode || "daily", tariff_revision: revision,
    start_date: period.start_date, end_date_planned: period.end_date_planned,
    ...(period.start_at ? {start_at: period.start_at, end_at: period.end_at} : {})};
}

export function isVehiclePriceCurrent(form, preview) {
  if (!preview || (form.pricing_mode || "daily") === "manual") return false;
  const pricing = preview.pricing, revision = pricing?.tariff?.revision;
  if (preview.inputKey !== vehiclePriceInputKey(form) || preview.priceKey !== vehiclePriceKey(form, revision)
      || !Number.isInteger(revision) || revision < 1 || pricing?.source !== "tariff"
      || pricing.tariff.kind !== "vehicle" || pricing.tariff.vehicle_id !== form.vehicle_id
      || pricing.mode !== (form.pricing_mode || "daily") || !Number.isSafeInteger(pricing.amount_cents) || pricing.amount_cents < 0) return false;
  try {
    const expected = vehiclePreviewPayload(form, revision);
    return ["start_date", "end_date_planned", "start_at", "end_at"].every(field => (pricing.period?.[field] || "") === (expected[field] || ""));
  } catch { return false; }
}

export function vehicleQuotePayload(form, preview, requestId) {
  const timed = timedPayload(form);
  const body = Object.fromEntries(quoteFields.filter(field => timed[field] !== undefined).map(field => [field, timed[field]]));
  if (!String(body.internal_note || "").trim()) delete body.internal_note;
  body.pricing_mode = form.pricing_mode || "daily";
  body.request_id = requestId;
  if (body.pricing_mode === "manual") return body;
  if (!isVehiclePriceCurrent(form, preview)) throw new Error("Attendi un prezzo aggiornato per il veicolo e il periodo selezionati prima di salvare.");
  delete body.agreed_amount;
  return {...body, pricing_source: "vehicle", tariff_revision: preview.pricing.tariff.revision, expected_amount_cents: preview.pricing.amount_cents};
}
